import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { contentActions, translateSentence, clearTranslationResult } from '../store/contentSlice';

export const useContentManagement = (formik) => {
    const dispatch = useDispatch();
    const rawTranslatingIndexes = useSelector(state => state.content?.translatingIndexes || []);
    const translationError = useSelector(state => state.content?.translationError);
    const translationResults = useSelector(state => state.content?.translationResults || {});
    
    // Ensure translatingIndexes is always an array (handle legacy Set format from persistence)
    const translatingIndexes = Array.isArray(rawTranslatingIndexes) 
        ? rawTranslatingIndexes 
        : Array.from(rawTranslatingIndexes || []);

    // Watch for translation results and update formik
    useEffect(() => {
        Object.entries(translationResults).forEach(([sentenceIndex, translations]) => {
            const index = parseInt(sentenceIndex);
            if (formik.values.content_ext[index]) {
                // Update the sentence with the translations
                const updatedContentExt = [...formik.values.content_ext];
                updatedContentExt[index] = {
                    ...updatedContentExt[index],
                    translation: translations
                };
                formik.setFieldValue('content_ext', updatedContentExt);
                
                // Clear the translation result from Redux state
                dispatch(clearTranslationResult({ sentenceIndex: index }));
            }
        });
    }, [translationResults, formik, dispatch]);

    return {
        translatingIndexes,
        translationError,
        addNewSentence: () => contentActions.addNewSentence(formik),
        deleteSentence: (sentenceIndex) => contentActions.deleteSentence(formik, sentenceIndex),
        moveSentence: (sentenceIndex, direction) => contentActions.moveSentence(formik, sentenceIndex, direction),
        updateSentenceContent: (sentenceIndex, content) => contentActions.updateSentenceContent(formik, sentenceIndex, content),
        addTranslation: (sentenceIndex) => contentActions.addTranslation(formik, sentenceIndex),
        deleteTranslation: (sentenceIndex, translationIndex) => contentActions.deleteTranslation(formik, sentenceIndex, translationIndex),
        updateTranslation: (sentenceIndex, translationIndex, field, value) => contentActions.updateTranslation(formik, sentenceIndex, translationIndex, field, value),
        translateSentence: (sentenceIndex) => dispatch(translateSentence(formik, sentenceIndex))
    };
}; 